export function ownsExtension(extension) {
  return Boolean(extension?.installation || extension?.author || (extension?.owned && extension?.accessPolicy !== 'free'))
}

export function filterExtensions(items, { engine = '', category = 'all', ownership = 'all' } = {}) {
  return items.filter(item => {
    if (engine && item.engine !== engine) return false
    if (category !== 'all' && item.category !== category) return false
    const owned = ownsExtension(item)
    return (ownership !== 'owned' || owned) && (ownership !== 'available' || !owned)
  })
}

export function engineName(id, engines) {
  return engines.find(engine => engine.id === id)?.name || id || 'Unspecified'
}
